import React from 'react';
import { Route, Redirect } from 'react-router';

export function PrivateRoute({ authorized, ...props }) {
    if (!authorized) {
        return <Redirect to="/forbidden" />
    }
    
    return <Route {...props} />
}